<template>
  <div class="section-title font-family">
    <slot></slot>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.section-title {
  font-size: 24px;
  color: #313131;
  text-align: left;
  border-bottom: 1px solid #d8d8d8;
}
</style>
